/* eslint-disable no-restricted-syntax */
import { Config, Helpers, InitializeTypes, IFinalResponse } from '@smiles/voebiz-core-engine';
import { Services } from '@smiles/voebiz-core-utils';
import { getEnvFromHost } from 'utils/getEnvFromHost';

const CoreHelpers = Helpers;
const CoreServices = Services;
let { smlsEnv } = window;

if (smlsEnv && smlsEnv.includes('uat')) {
  smlsEnv = smlsEnv.replace(/uat/, 'hml');
}
const configLib: InitializeTypes = {
  service: {
    environment: getEnvFromHost(),
    logger: false,
    timeout: 60000,
    region: 'Brasil',
  },
  channel: 'WEB',
  receiveConstants: true,
  loggerXstate: false,
};
export const constants = {};
export function init() {
  return Config.initialize(configLib);
}
export { CoreHelpers, CoreServices, Config };
export type { IFinalResponse };
